import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './ModernBanner.scss';
import { FaArrowDown, FaRocket, FaChartLine, FaShieldAlt, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { media_url } from '../../hooks/useBlog';

const ModernBanner = () => {
  const { currentCustomer } = useSelector((state) => state.store);
  const { banners } = useSelector((state) => state.blog);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Inicializar AOS
    AOS.init({
      duration: 800,
      once: true,
      offset: 100
    });
    
    setIsVisible(true);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 20,
        y: (e.clientY / window.innerHeight) * 20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight - 100,
      behavior: 'smooth'
    });
  };

  // Configuración del slider personalizado
  function SlickNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={`${className} modern-arrow modern-arrow-next`} onClick={onClick}>
        <FaAngleRight />
      </div>
    );
  }

  function SlickPrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div className={`${className} modern-arrow modern-arrow-prev`} onClick={onClick}>
        <FaAngleLeft />
      </div>
    );
  }

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'cubic-bezier(0.87, 0, 0.13, 1)',
    pauseOnHover: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    nextArrow: <SlickNextArrow />,
    prevArrow: <SlickPrevArrow />,
    appendDots: dots => (
      <div className="modern-dots">
        <ul> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div className={`modern-dot ${i === currentSlide ? 'active' : ''}`}>
        <span className="dot-progress"></span>
      </div>
    )
  };

  return (
    <div className={`modern-banner ${isVisible ? 'visible' : ''}`} style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Slider de Banners - Si existen banners, mostrar slider */}
      {banners && banners.length > 0 && (
        <div className="modern-banner-slider" data-aos="fade-in">
          <Slider {...sliderSettings} className="hero-slider">
            {banners.map((banner, index) => (
              <div key={banner.id || index} className="slide-item">
                <div 
                  className="slide-image"
                  style={{
                    backgroundImage: `url(${media_url(banner.image)})`,
                  }}
                  onClick={() => banner.link && window.open(banner.link, '_blank')}
                >
                  <div className="slide-overlay"></div>
                  {banner.title && (
                    <div className="slide-content">
                      <h2 className="slide-title">{banner.title}</h2>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}

      {/* Fondo animado con gradiente dinámico */}
      <div className="animated-background">
        <div className="gradient-orb orb-1" style={{
          transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`
        }}></div>
        <div className="gradient-orb orb-2" style={{
          transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)`
        }}></div>
        <div className="gradient-orb orb-3" style={{
          transform: `translate(${mousePosition.y}px, ${mousePosition.x}px)`
        }}></div>
      </div>

      {/* Grid de fondo */}
      <div className="grid-background"></div>

      {/* Partículas flotantes */}
      <div className="floating-particles">
        {[...Array(30)].map((_, i) => (
          <div 
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${10 + Math.random() * 20}s`
            }}
          ></div>
        ))}
      </div>

      {/* Contenido principal */}
      <div className="banner-content banner-container">
        <div className="content-wrapper">
          {/* Badge superior */}
          <div className="top-badge" data-aos="fade-down">
            <span className="badge-dot"></span>
            <span>Plataforma Digital</span>
          </div>

          {/* Título principal con efecto de escritura */}
          <h1 className="main-title" data-aos="fade-up" data-aos-delay="200">
            <span className="title-line"></span>
            <span className="title-line gradient-text">{window["configSite"]?.siteTitle || "Transformación"}</span>
            <span className="title-line"></span>
          </h1>

          {/* Subtítulo */}
          <p className="subtitle" data-aos="fade-up" data-aos-delay="400">
            {window["configSite"]?.siteDescription || 
              "Moderniza la gestión pública con tecnología de vanguardia. Simplifica trámites, mejora servicios y conecta con tus ciudadanos."}
          </p>

          {/* CTAs principales */}
          <div className="cta-buttons" data-aos="fade-up" data-aos-delay="600">
            <button 
              className="btn-primary-modern"
              onClick={() => {
                window.open(
                  `https://${window.location.host}${window["APP_HOME"]}`,
                  "_blank"
                );
              }}
            >
              <FaRocket />
              <span>Ingresar</span>
              <div className="btn-glow"></div>
            </button>
            
            <button className="btn-secondary-modern" onClick={scrollToContent}>
              <span>Descubre Más</span>
              <FaArrowDown />
            </button>
          </div>

          {/* Stats cards flotantes */}
          <div className="stats-cards" data-aos="fade-up" data-aos-delay="800">
            <div className="stat-card">
              <div className="stat-icon">
                <FaRocket />
              </div>
              <div className="stat-content">
                <h3>100+</h3>
                <p>Trámites Digitalizados</p>
              </div>
            </div>

            <div className="stat-card" data-aos-delay="900">
              <div className="stat-icon">
                <FaChartLine />
              </div>
              <div className="stat-content">
                <h3>50K+</h3>
                <p>Usuarios Activos</p>
              </div>
            </div>

            <div className="stat-card" data-aos-delay="1000">
              <div className="stat-icon">
                <FaShieldAlt />
              </div>
              <div className="stat-content">
                <h3>99.9%</h3>
                <p>Uptime Garantizado</p>
              </div>
            </div>
          </div>
        </div>

        {/* Imagen/Ilustración lateral */}
        <div className="banner-illustration" data-aos="fade-left" data-aos-delay="400">
          <div className="illustration-wrapper">
            <div className="floating-element element-1">
              <div className="element-inner"></div>
            </div>
            <div className="floating-element element-2">
              <div className="element-inner"></div>
            </div>
            <div className="floating-element element-3">
              <div className="element-inner"></div>
            </div>
            <div className="illustration-center">
              <div className="center-circle">
                <div className="pulse-ring"></div>
                <div className="pulse-ring ring-2"></div>
                <div className="center-icon">🏛️</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator" onClick={scrollToContent}>
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div className="arrow-down">
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Wave divider */}
      <div className="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default ModernBanner;
